import { render, staticRenderFns } from "./SchoolExamList.vue?vue&type=template&id=068816ae&scoped=true&"
import script from "./SchoolExamList.vue?vue&type=script&lang=js&"
export * from "./SchoolExamList.vue?vue&type=script&lang=js&"
import style0 from "./SchoolExamList.vue?vue&type=style&index=0&id=068816ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068816ae",
  null
  
)

export default component.exports